import { getDayName } from "lib/date";
import {
  orderStatusOptions,
  paymentStatusOption
} from "lib/global";
import { serverPost } from "lib/serverRequest";

export const getWeeklySlots = ({ data = "", onFinish = () => {} }) => {
  serverPost({ url: `weeklySlots`, data: data, onFinish: onFinish });
};

export const getBakesDates = ({ data = {}, onFinish = () => {} }) => {
  serverPost({ url: `weeklySlots/bakeDates`, data: data, onFinish: onFinish });
};

export const getUserWeeklySlots = ({ data = "", onFinish = () => {} }) => {
  serverPost({ url: `weeklySlots/user`, data: data, onFinish: onFinish });
};

export const getBoxesWithYear = ({ data = {}, onFinish = () => {} }) => {
  serverPost({
    url: "weeklySlots/dashboard/pieBox",
    data: data,
    onFinish: onFinish,
  });
};

export const getAllOrders = ({ data = {}, onFinish = () => {} }) => {
  serverPost({
    url: "weeklySlots/all",
    data: data,
    onFinish: onFinish,
  });
};

export const updateSelectedSlots = ({ data = {}, onFinish = () => {} }) => {
  serverPost({
    url: "weeklySlots/update/selectedSlots",
    data: data,
    onFinish: onFinish,
  });
};

export const checkWeeklySlotLog = ({ newValue = {}, initData = {} }) => {
  let log = "";
  const checkLogKeys = [
    "paid",
    "status",
    "week_day",
    "week_num",
    "week_year",
    "delivery_note",
  ];
  const diffKeys = checkLogKeys?.reduce(
    (ret, key, index) =>
      Boolean((newValue?.[key] ?? "") !== (initData?.[key] ?? ""))
        ? [...ret, key]
        : ret,
    []
  );
  if (diffKeys?.length > 0) {
    let changeKeys = "";
    let changeValues = "";
    diffKeys.forEach((ele, index) => {
      let key = "";
      let value = "";
      switch (ele) {
        case "week_day":
          key = "Week day";
          value = getDayName(newValue?.[ele] ?? 1);
          break;
        case "week_num":
          key = "Week number";
          value = `week ${newValue?.[ele] ?? 1}`;
          break;
        case "week_year":
          key = "Week year";
          value = newValue?.[ele] ?? 2023;
          break;
        case "delivery_note":
          key = "Delivery note";
          value = newValue?.[ele];
          break;
        case "status":
          key = "Order status";
          value = orderStatusOptions.find(
            (item) => item?.id === String(newValue?.[ele])
          )?.label;
          break;
        default:
          key = "Paid status";
          value = paymentStatusOption.find(
            (item) => item?.id === String(newValue?.[ele])
          )?.label;
          break;
      }
      changeKeys += index === diffKeys?.length - 1 ? key : `${key}, `;
      changeValues += index === diffKeys?.length - 1 ? value : `${value}, `;
    });
    log = `${changeKeys} - "${changeValues}"`;
  }
  return log;
};

export const sendCustomEmail = ({ data = {}, onFinish = () => {} }) => {
  serverPost({
    url: "weeklySlots/move/customEmail",
    data: data,
    onFinish: onFinish,
  });
};

export const downloadCsv = ({ data = {}, onFinish = () => {} }) => {
  serverPost({
    url: "weeklySlots/downloadCsv",
    data: data,
    onFinish: onFinish,
  });
};
